import { Button, Group } from "@mantine/core";
import { useState } from "react";
import { useSessionStore } from "../../../stores/UserStore";
import { useLanguage } from "../../../stores/LanguageStore";
import { mainAxios } from "../../../api/axios";
import { IconGmail } from "../../../components/Icons/IconGmail";
import { IconOutlook } from "../../../components/Icons/IconOutlook";
import { IconGithub } from "../../../components/Icons/IconGithub";
import { appHost } from "../../../functions/appHost";

const OAuthButtons = ({ isMobile, ...props }) => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);

  const [oAuth, setOAuth] = useState(null);

  const handleOauth = (type) => {
    const params = new URLSearchParams(location.search);
    let ref = params.get("ref");
    let team_code = params.get("team_code");
    let organization_code = params.get("organization_code");

    // Data
    const data = {};

    data.domain_saas =
      reseller?.domain_saas3 === "application.magileads.io"
        ? null
        : reseller?.domain_saas3 || reseller?.domain_saas2 || null;
    data.email_validation_url_success = `https://${appHost(reseller)}/success/account?lang=${lang.id}`;
    data.email_validation_url_error = `https://${appHost(reseller)}/email-not-validated?lang=${lang.id}`;
    data.language = lang.id;
    data.referred_user_id = parseInt(ref) || null;
    data.team_codes = team_code ? [team_code] : null;
    data.organization_code = organization_code ? [organization_code] : null;
    data.show_onboarding = true;

    setOAuth(type);

    mainAxios
      .post(`https://${reseller.domain_api}/oauth/${type}/redirect`, data)
      .then((response) => {
        window.open(response.data.location, "_self");
      })
      .finally(() => {
        setOAuth(null);
      });
  };

  return (
    <Group w={"100%"} mt={8} {...props}>

      {
        ((reseller?.name !== "Magileads" &&
          reseller?.options?.find((x) => x.name === "ShowRegisterConnectionGmail")
            ?.active) ||
          reseller?.name === "Magileads") &&
        <Button
          onClick={() => handleOauth("google")}
          loading={oAuth === "google"}
          w={"100%"}
          size={isMobile ? "sm" : "md"}
          variant="outline"
          style={{
            borderColor: "var(--mantine-color-primary-6)",
          }}
          bg={"primary.0"}
          c={"black"}
          justify="start"
          pl={32}
          radius={"md"}
          leftSection={<IconGmail size={16} />}
        >
          {lang.login.continue_with} Google
        </Button>
      }

      {((reseller?.name !== "Magileads" &&
        reseller?.options?.find((x) => x.name === "ShowRegisterConnectionOutlook")
          ?.active) ||
        reseller?.name === "Magileads") && (
          <Button
            onClick={() => handleOauth("microsoft")}
            loading={oAuth === "microsoft"}
            w={"100%"}
            size={isMobile ? "sm" : "md"}
            variant="outline"
            style={{
              borderColor: "var(--mantine-color-primary-6)",
            }}
            bg={"primary.0"}
            c={"black"}
            justify="start"
            pl={32}
            radius={"md"}
            leftSection={<IconOutlook size={18} />}
          >
            {lang.login.continue_with} Outlook
          </Button>
        )}

      {
        reseller?.name === "Magileads" &&
        <Button
          onClick={() => handleOauth("github")}
          loading={oAuth === "github"}
          w={"100%"}
          size={isMobile ? "sm" : "md"}
          variant="outline"
          style={{
            borderColor: "var(--mantine-color-primary-6)",
          }}
          bg={"primary.0"}
          c={"black"}
          justify="start"
          pl={32}
          radius={"md"}
          leftSection={<IconGithub size={18} />}
        >
          {lang.login.continue_with} Github
        </Button>
      }
    </Group>
  );
};

export default OAuthButtons;
